import { useCallback } from 'react';

export default function SectionApp() {
  const handleImgError = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.setAttribute('data-failed', 'true');
  }, []);

  return (
    <section id="app" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 bg-gradient-to-r from-background-200/90 to-background-200/60 rounded-2xl p-6 md:p-10 border border-background-300/40">
          <div className="w-20 h-20 md:w-24 md:h-24 shrink-0 rounded-2xl bg-primary-500/15 flex items-center justify-center border border-primary-500/25">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-400"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              随时随地追剧观影
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-400 max-w-lg">
              麻花影视移动端适配，手机、平板、电脑多端同步观影。收藏片单、观看记录云端同步，走到哪看到哪，高清不缓冲。
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <button className="px-6 py-2.5 bg-foreground-50 hover:bg-foreground-100 text-background-900 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-apple-fill mr-1.5"></i>
              iOS 下载
            </button>
            <button className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-android-fill mr-1.5"></i>
              安卓下载
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}